import { apiFetch } from '../utils/apiClient';

const ACCOUNT_API_BASE =
  process.env.REACT_APP_AccountAMP_Url || 'https://momentumampapi-stage.insurancegig.com';

const BASE = `${ACCOUNT_API_BASE}/api/MCP_APIKeys`;

export interface SavedApiKey {
  id: number;
  userId: number;
  companyId: number;
  apiKeyId: string;
  nowcertUserId: string;
  generatedApiKey: string;
  description: string;
  isRevoked: boolean;
  created: string;
}

export interface GenerateKeyResponse {
  status: number;
  message: string;
  data: {
    id: string;
    apiKey: string;
  };
}

function getAmsToken(): string {
  return localStorage.getItem('amsToken') || '';
}

export async function getApiKeys(): Promise<SavedApiKey[]> {
  return apiFetch<SavedApiKey[]>(`${BASE}`);
}

export async function generateApiKey(description: string): Promise<GenerateKeyResponse> {
  return apiFetch<GenerateKeyResponse>(`${BASE}/generate`, {
    method: 'POST',
    headers: { 'Nc-Token': getAmsToken() },
    body: JSON.stringify({ description }),
  });
}

export async function revokeApiKey(keyId: string): Promise<void> {
  return apiFetch<void>(`${BASE}/revoke/${encodeURIComponent(keyId)}`, {
    method: 'POST',
    headers: { 'Nc-Token': getAmsToken() },
  });
}
